import { render, staticRenderFns } from "./RequestCreditStatusBadge.vue?vue&type=template&id=16d97ed8&scoped=true&"
import script from "./RequestCreditStatusBadge.vue?vue&type=script&lang=js&"
export * from "./RequestCreditStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./RequestCreditStatusBadge.vue?vue&type=style&index=0&id=16d97ed8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d97ed8",
  null
  
)

component.options.__file = "RequestCreditStatusBadge.vue"
export default component.exports